/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { updateProject as updateProjectService, TUpdateProjectRequest } from 'shared/services/updateProject';
import { showAlert } from 'shared/slices/admin/alert';
import { EAlert } from 'shared/types/alert';

/* istanbul ignore next */
export const updateProject = createAsyncThunk<Boolean, TUpdateProjectRequest, IThunkApi>(
  'projects/update',
  async (params, { extra: context, dispatch, rejectWithValue }) => {
    try {
      const isUpdated = await updateProjectService(context, params);

      if (isUpdated) {
        dispatch(showAlert({ message: 'Проект успешно обновлен', type: EAlert.Info }));
      } else {
        dispatch(showAlert({ message: 'Проект не обновлен', type: EAlert.Error }));
      }

      return isUpdated;
    } catch (_) {
      dispatch(showAlert({ message: 'Проект не обновлен', type: EAlert.Error }));

      return rejectWithValue(false);
    }
  },
  {
    /**
     * Можно предотвратить вызов thunk-а через специальный объект с условием
     * (полезно, например, в случаях, если идет загрузка и надо предотвратить повторный запрос)
     */
    // condition: (params, _api) => {
    //   /**
    //    * В api есть стейт и extra
    //    *
    //    * сonst { getState, extra } = api;
    //    */
    //   const { getState } = _api;
    //   const {
    //     demo: { test },
    //   } = getState();
    //   return test;
    // },
  },
);
